import { HiOutlineDotsVertical } from "react-icons/hi";

export const OptionAltIcon = ({ ...rest }) => {
  return <HiOutlineDotsVertical {...rest} />;
};
